import React from 'react';
import { createStyles, makeStyles, Theme, List, ListItem, ListItemText } from '@material-ui/core';

export interface Props {
  messagesObject?: object
  messages?: string[];
  secondaryText?: string;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    listItem: {
      padding: theme.spacing(0, 0),
    },
  })
);

const MessageList: React.FunctionComponent<Props> = (props) => {
  const classes = useStyles();
  const { messagesObject, messages, secondaryText } = props;
  return (
    <List>
      {messagesObject && Object.entries(messagesObject).map(([k, v]) => {
        return (
          <ListItem key={k} className={classes.listItem}>
            <ListItemText primary={k} secondary={`${v}`} />
          </ListItem>
        );
      })}
      {messages && messages.map((msg) => {
        return (
          <ListItem key={msg} className={classes.listItem}>
            <ListItemText primary={msg} />
          </ListItem>
        );
      })}
      {secondaryText && <ListItemText primary={secondaryText} />}
    </List>
  );
};

export default MessageList;